import React from 'react';
import { Cell } from 'react-table';
import cx from 'classnames';

import { IconLayoutTopPanel5 } from '@trqk/components';

import { rowHeight } from '../constants';
import { useGapAnalysisTools } from '../../../../../../hooks';

interface ViewCellProps {
    cell: Cell<TrqkGapSummary, GapSummaryReportViewCellValue>;
}

/**
 * Displays a button that allows the user to view a gap analysis report.
 * @param props - {@link ViewCellProps}
 * @returns JSX
 */
export function ViewCell({ cell }: ViewCellProps): JSX.Element {
    const { openViewGapAnalysis } = useGapAnalysisTools();
    const {
        value: { gapAnalysisId, complete },
    } = cell;

    return (
        <div className="flex items-center" style={{ height: rowHeight }}>
            <button
                type="button"
                disabled={!complete}
                className={cx({ 'cursor-default': !complete })}
                onClick={() => {
                    openViewGapAnalysis(gapAnalysisId);
                }}
            >
                <IconLayoutTopPanel5
                    width={24}
                    fillColor={complete ? 'primary-500' : 'tertiary-300'}
                />
            </button>
        </div>
    );
}
